import React, { useEffect, useState } from 'react';
import { formatSeoApiError, listSeoCronRuns } from '../../../utils/adminSeo';

export default function SeoCronRunsScreen() {
  const [runs, setRuns] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    listSeoCronRuns({ limit: 40 })
      .then((r) => setRuns(r.runs || []))
      .catch((e) => setErr(formatSeoApiError(e)));
  }, []);

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#1B375B]">Cron Runs</h2>
      {err && <p className="text-red-600 text-sm">{err}</p>}
      <div className="bg-white border rounded overflow-x-auto max-h-[70vh]">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 sticky top-0">
            <tr>
              <th className="p-2 text-left">Job</th>
              <th className="p-2">Status</th>
              <th className="p-2">Duration</th>
              <th className="p-2 text-left">Stats</th>
            </tr>
          </thead>
          <tbody>
            {runs.map((r) => (
              <tr key={r.id} className="border-t">
                <td className="p-2">{r.job_id}</td>
                <td className="p-2">{r.status}</td>
                <td className="p-2 text-center">{r.duration_ms != null ? `${r.duration_ms}ms` : '—'}</td>
                <td className="p-2 text-xs font-mono">{JSON.stringify(r.stats || {})}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {runs.length === 0 && !err && <p className="p-4 text-gray-500 text-sm">No cron runs logged yet.</p>}
      </div>
    </div>
  );
}
